import 'es6-promise/auto'
import axios from 'axios'
import { debounce, isEmpty, isNumber } from '~/misc/Utils'
import { on } from 'delegated-events'

class App {
    constructor() {
        this.getDom()
        this.bindEvents()
        this.fetchPoles()
        this.init()
    }

    getDom() {
        this.originalPrice = null
        this.form = document.querySelector('.pole-product-form')
        this.widthProperty = this.form.querySelector('.width-property')
        this.colourProperty = this.form.querySelector('.colour-property')
        this.widthInput = this.form.querySelector('.pole-width-input')
        this.button = this.form.querySelector('.product-form--atc-button')
        this.price = document.querySelector('.product-pricing .money')
        this.productId = this.form.querySelector('input[name="id"]')
        this.purchasableId = this.form.querySelector('input[name="id"]')
        this.flyOutCartBanner = document.querySelector('.atc-banner--container')
        this.errorMsg = this.form.querySelector('.pole-width-error')
        this.header = document.querySelector('[data-site-header]')
        this.optionValueInput = this.form.querySelectorAll('.option-value-input')
        this.quantitySelector = this.form.querySelector('.form-field--qty-select select')
        this.poles = []
        this.maxWidth = 300
        this.totalPrice = 0
    }

    bindEvents() {
        this.button.addEventListener('click', this.handleButtonSubmit.bind(this))
        this.widthInput.addEventListener('input', debounce(this.handleInput.bind(this), 500))
        on('click', '.atc-banner--close', this.handleClose.bind(this))
    }

    init() {
        this.originalPrice = this.price.textContent
    }

    handleInput(event) {
        const width = parseFloat(event.target.value)
        this.errorMsg.innerHTML = ''

        let total = 0

        if (!isNumber(this.widthInput.value)) {
            return
        }

        console.log('poles:', this.poles)

        const pole = this.poles.filter((item) => {
            return width >= parseInt(item.min_width) && width <= parseInt(item.max_width)
        })

        if (pole.length > 0) {
            total = parseFloat(pole[0].rrp)
        }

        //console.log('found matching pole:', pole)

        if (parseFloat(this.widthInput.value) > this.maxWidth) {
            this.errorMsg.innerHTML = `The maximum width is ${this.maxWidth}cm. Please <a href="/pages/contact-us">contact us</a> for a bespoke order.`
            return
        }

        if (total == 0 || isEmpty(width)) {
            this.price.textContent = this.originalPrice
            return
        }

        this.widthProperty.value = `${width}cm`
        this.totalPrice = total

        this.price.textContent = new Intl.NumberFormat('en-GB', {
            style: 'currency',
            currency: window.currencyInformation.code,
        }).format(total)
    }

    handleButtonSubmit(event) {
        event.preventDefault()

        if (!isNumber(this.widthInput.value)) {
            this.errorMsg.innerHTML = 'Please enter a valid width.'
            return
        }

        if (isEmpty(this.widthInput.value)) {
            this.errorMsg.innerHTML = 'Please enter your pole width.'
            return
        }

        if (this.poles.length == 0) {
            this.errorMsg.innerHTML = 'There was an error. Please <a href="/pages/contact-us">contact us</a> for a bespoke order.'
            return
        }

        if (parseFloat(this.widthInput.value) > this.maxWidth) {
            this.errorMsg.innerHTML = `The maximum width is ${this.maxWidth}cm. Please <a href="/pages/contact-us">contact us</a> for a bespoke order.`
            return
        }

        this.errorMsg.textContent = ''
        this.disableButton()

        const quantity = parseInt(this.quantitySelector.value)

        const payload = {
            items: [
                {
                    id: parseInt(this.productId.value),
                    quantity: this.totalPrice * quantity,
                    properties: {
                        Width: `${this.widthInput.value}cm`,
                        Quantity: quantity,
                    },
                },
            ],
        }

        // console.log('payload:', payload)

        this.optionValueInput.forEach((input) => {
            if (input.checked) {
                const key = input.name.toLowerCase()
                const options = ['colour', 'color', 'Colour', 'Color']

                if (options.includes(key)) {
                    payload.items[0].properties[key] = input.value
                }

                this.colourProperty.value = input.value
            }
        })

        this.AddFormDataToCart(payload, quantity)
    }

    async fetchPoles() {
        try {
            const response = await axios.get('https://tori-murphy.strafe.dev/api/v1/product/load/poles')
            this.buidPoleOptions(response.data)
        } catch (error) {
            console.error('error:', error)
        }
    }

    buidPoleOptions(poles) {
        console.log('poles data:', poles)

        const options = []
        let tags = this.widthInput.dataset.tags

        if (!isEmpty(tags)) {
            tags = tags.split(',')
        } else {
            tags = []
        }

        Object.keys(poles).forEach((key) => {
            poles[key].forEach((pole) => {
                if (tags.includes(pole.tag)) {
                    options.push(pole)
                }
            })
        })

        // Find the pole with biggest max_width
        const sortedPole = options.sort((a, b) => {
            return parseInt(b.max_width) - parseInt(a.max_width)
        })

        if (sortedPole.length > 0) {
            this.maxWidth = parseInt(sortedPole[0].max_width)
        }

        this.poles = options
    }

    AddFormDataToCart(payload, quantity) {
        // const formData = new FormData(this.form)
        const url = ''.concat(window.Theme.routes.cart_add_url, '.js')

        axios
            .post(url, payload)
            .then((response) => {
                const { data } = response

                if (data.status === 422) {
                    throw new Error('Error: 422')
                    return
                }

                this.CartFlyout(data.items[0], quantity)
                this.enableButton()
            })
            .catch((error) => {
                console.error('error:', error)
                this.enableButton()
            })
    }

    CartFlyout(data, quantity) {
        const image = this.flyOutCartBanner.querySelector('.atc--product .atc--product-image')
        const title = this.flyOutCartBanner.querySelector('.atc--product-details--title')
        const subTotalPrice = this.flyOutCartBanner.querySelector('.atc-subtotal--price')
        const priceValue = this.flyOutCartBanner.querySelector('.atc--product-details--price-value')
        const priceQuantity = this.flyOutCartBanner.querySelector('.atc--product-details--price-quantity')
        const currency = window.currencyInformation

        if (image) {
            const img = new Image()
            img.src = data.image
            image.innerHTML = ''
            image.appendChild(img)
        }

        if (title) {
            title.textContent = data.product_title
        }

        if (subTotalPrice) {
            subTotalPrice.textContent = Shopify.formatMoney(data.final_line_price, `${currency.symbol}{{amount}}`)
        }

        if (priceValue) {
            priceValue.textContent = Shopify.formatMoney(data.final_line_price, `${currency.symbol}{{amount}}`)
        }

        if (priceQuantity) {
            priceQuantity.textContent = `${quantity} x`
        }

        this.flyOutCartBanner.classList.add('visible')

        const flyOut = this.flyOutCartBanner.cloneNode(true)
        this.header.appendChild(flyOut)
        this.clearForm()

        window.api.theme.triggerEvent('cart:updated')
    }

    handleClose(even) {
        even.preventDefault()
        const element = even.target.closest('.atc-banner--container')

        if (element) {
            element.classList.remove('visible')

            setTimeout(() => {
                element.remove()
            }, 500)
        }
    }

    handleOffClick(event) {
        event.preventDefault()
        const element = event.target.closest('.atc-banner--container')
        //console.log('element:', element)
    }

    clearForm() {
        this.widthInput.value = ''
        this.widthProperty.value = ''
        this.colourProperty.value = ''
    }

    disableButton() {
        this.button.classList.add('processing')
        this.button.disabled = true
    }

    enableButton() {
        this.button.classList.remove('processing')
        this.button.disabled = false
    }
}

new App()
